import ActionTypes from '../constants';

const initialState = {
    insuranceCompanies: {},
    insuranceCompany: {}
    // loading: false,
};

const insuranceCompanyReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETINSURANCECOMPANYSUCCESS:
            return {
                ...state,
                insuranceCompanies: action.payload,
            }
        case ActionTypes.GETINSURANCECOMPANYBYIDSUCCESS:
            return {
                ...state,
                insuranceCompany: action.payload,
            }
        default:
            return state;
    }
}

export default insuranceCompanyReducer;